import { Component } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { DataAccessExhibitorsFacade, DataAccessProductsFacade } from '@planone/bau365/data-access-fair-data';
import { Exhibitor, Product } from '@planone/bau365/util-fair-data';
import { Observable } from 'rxjs';

@Component({
  selector: 'bau365-country-availability-modal',
  templateUrl: './country-availability-modal.component.html',
  styleUrls: ['./country-availability-modal.component.scss'],
})
export class CountryAvailabilityModalComponent {
  product$: Observable<Product | undefined>;
  productLoading$: Observable<boolean | undefined>;
  productError$: Observable<string | undefined>;
  exhibitor$: Observable<Exhibitor | undefined>;

  constructor(
    public dialog: MatDialog,
    private productsFacade: DataAccessProductsFacade,
    private exhibitorsFacade: DataAccessExhibitorsFacade
  ) {
    this.product$ = productsFacade.product$;
    this.productLoading$ = productsFacade.productLoading$;
    this.productError$ = productsFacade.productError$;
    this.exhibitor$ = exhibitorsFacade.exhibitor$;
  }

  trackByCountry = (index: number, _country: string) => index;
}
